import { useCallback, useContext } from "react";

import { IMessageContext, MessageContext } from "@/context/message-context";

type SnackbarVariant = "error" | "warning" | "info" | "success";

type IShow = (
  message: string,
  snackBarDescription: string,
  variant: SnackbarVariant,
  duration?: number
) => void;

interface ISnackBarReturn {
  show: IShow;
  hide: () => void;
}

const useSnackbar = (): ISnackBarReturn => {
  const { showSnackbar, hideSnackbar } = useContext(
    MessageContext
  ) as IMessageContext;

  const show: ISnackBarReturn["show"] = useCallback(showSnackbar, [
    showSnackbar,
  ]);
  const hide: ISnackBarReturn["hide"] = useCallback(hideSnackbar, [
    hideSnackbar,
  ]);

  return { show, hide };
};

export default useSnackbar;
